import { html } from "../../helpers/html-template.js";
import { EditorClasses } from "../../styles.js";
import { toVueComponent } from "@scalar-org/vue-render";
function guideImageHtml(props) {
  const classes = [
    "image-upload-container",
    "relative",
    `custom-image-size-${props.size}`,
    EditorClasses.Image
  ].join(" ");
  if (!props.src) return "";
  return html`
    <figure
      class="${classes}">
      <a
        ${props.href ? `href="${props.href}"` : ""}
        rel="noopener noreferrer"
        target="_blank">
        <img
          alt="${props.alt}"
          class="highlight-active"
          data-dark-mode-src="${props["src-dark"] || ""}"
          data-scalar-type="image"
          data-scalar-name="scalar-image"
          data-src="${props.src}"
          ${props.height ? `height="${props.height}"` : ""}
          src="${props.activeSrc || props.src}"
          ${props.width ? `width="${props.width}"` : ""} />
      </a>
      ${props.isTipTap ? '<ssg-children name="controls" ></ssg-children>' : ""}
      ${props.caption ? `<figcaption>${props.caption}</figcaption>` : ""}
    </figure>
  `;
}
const ScalarImageVue = toVueComponent(guideImageHtml, {
  activeSrc: String,
  src: String,
  "src-dark": String,
  // darkModeSrc: String,
  width: Number,
  height: Number,
  alt: String,
  caption: String,
  href: String,
  size: String,
  isTipTap: Boolean
});
export {
  ScalarImageVue,
  guideImageHtml
};
//# sourceMappingURL=component.js.map
